import type { DumpRow, Preset } from "./types";
import { resolveCellValue } from "./source-fields";

function escapeCell(value: string): string {
  if (value === "") return "";
  if (/[",\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function rowsToCsv(rows: DumpRow[], preset: Preset): string {
  const cols = preset.columns;
  if (cols.length === 0) return "";

  const headerLine = cols.map((c) => escapeCell(c.header)).join(",");
  const lines = [headerLine];
  for (const r of rows) {
    lines.push(cols.map((c) => escapeCell(resolveCellValue(r, c))).join(","));
  }
  return lines.join("\r\n");
}
